import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { REVIEW } from '../../../../../../constants/queryKeys';
import { AxiosError } from 'axios';
import ReviewApiV2 from '../../../../../../lib/api/cs/review/ReviewApiV2';
import { ReviewsExcelSheetRequestType } from '../../types/ReviewListType';
import { AdminExcelDownloadAcceptedResponseType } from '../../../../../../types/api/reviews';

const useReviewListExcelDownload = (): UseMutationResult<
  AdminExcelDownloadAcceptedResponseType,
  AxiosError,
  ReviewsExcelSheetRequestType,
  unknown
> => {
  return useMutation<AdminExcelDownloadAcceptedResponseType, AxiosError, ReviewsExcelSheetRequestType, unknown>(
    [REVIEW.EXCEL_DOWNLOAD],
    (payload: ReviewsExcelSheetRequestType) => ReviewApiV2.downloadReviewExcelSheet(payload),
    {
      onError: (err: AxiosError) => {
        throw err;
      },
    },
  );
};

export default useReviewListExcelDownload;
